import * as React from "react";
import { Heading, Text } from "@nju/ui";
export interface ITitleProps {
  downloadSpeed: string;
}

export function Title({ downloadSpeed }: ITitleProps) {
  return (
    <>
      <Heading font="ttfirs" tone="neutral" variant="h4" weight="bold">
        <Text
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyS",
          }}
          weight="bold"
        >
          nju światłowód do{" "}
          <Text
            display={{
              "@onlyMobile": "block",
              "@fromTablet": "inline",
            }}
            size={{
              "@onlyMobile": "xl",
              "@fromTablet": "keyS",
            }}
            weight="bold"
          >
            {downloadSpeed}
          </Text>
        </Text>
      </Heading>
      <Text
        size={{
          "@onlyMobile": "s",
        }}
      >
        umowa na czas nieokreślony - rezygnujesz, kiedy chcesz
      </Text>
    </>
  );
}
